export default __webpack_public_path__ + "static/media/Settings-Default.59dee8ed.svg";